import { StoryStyles } from "./styles";
import { Languages } from "./language";

export const StoryDefault = Object.freeze({
  buddy_description: "",
  buddy_name: "",
  buddy_relationship: "",
  challenge: "",
  kid_age: "",
  kid_description: "",
  kid_name: "",
  learning: "",
  object: "",
  scenario: "",
});

export const StorySettings = Object.freeze({
  aspect_ratio: "3:4",
  images_style: StoryStyles.GOLDEN_LIGHT,
  language: Languages.SPANISH,
  num_characters_page: "300",
});

export const StoryStatus = Object.freeze({
  ERROR: "error",
  FAILED: "failed",
  LOADING: "loading",
  PENDING: "pending",
  SUCCESS: "success",
});

export const storyMessages = [
  [
    "Imaginando un cuento mágico...",
    "Buscando dragones, princesas y aventuras...",
    "Pintando los escenarios más coloridos...",
    "Añadiendo sorpresas, héroes y criaturas mágicas...",
    "Empaquetando la historia con un lazo brillante...",
    "¡Realizando los últimos ajustes mágicos!",
  ],
  [
    "Soñando una aventura increíble...",
    "Reuniendo personajes fantásticos...",
    "Construyendo un mundo lleno de magia...",
    "Agregando giros divertidos y momentos asombrosos...",
    "Decorando el cuento con emoción y alegría...",
    "¡Preparando la historia para que cobre vida!",
  ],
  [
    "Tejiendo una historia de ensueño...",
    "Descubriendo tesoros escondidos en la imaginación...",
    "Buscando la chispa de la creatividad...",
    "Añadiendo risas, sorpresas y magia...",
    "Envolviendo la historia con un toque especial...",
    "¡Casi listo para compartir la magia!",
  ],
];
